import React, { useEffect, useState} from 'react';
import {
    Avatar, Backdrop,
    Box,
    Card,
    CardHeader, Collapse, Fade, IconButton, useTheme,
    List, ListItem,
    ListItemAvatar, ListItemText, Modal, Typography
} from "@material-ui/core";
import clsx from 'clsx';
import Tooltip from '@material-ui/core/Tooltip';

import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import RoomIcon from '@material-ui/icons/Room';

import LaunchIcon from '@material-ui/icons/Launch';

import Map from "../Components/Map/Map";
import Snackbar from "../Components/Snackbar";

import {useStyles} from "./Details";
import ExploreIcon from "@material-ui/icons/Explore";
import {useLocation} from "react-router-dom";
import axios from "axios";
import { endpoints } from "../constants";
import { formatDateTimeToLastSeen, copyLocation } from '../helpers'
import BluetoothSearchingIcon from "@material-ui/icons/BluetoothSearching"
import NotListedLocationIcon from "@material-ui/icons/NotListedLocation"

const Follow = () => {
    const classes = useStyles()
    const theme = useTheme()
    const [snackbar, setSnackbar] = useState<{message: string, open: boolean, severity: 'info' | 'success' | 'error'}>({ message: '', open: false, severity: 'success'})
    const [lastSeen, setLastSeen] = useState('Seconds ago')
    const [expandedVehicle, setExpandedVehicle] = useState(false)
    const [expandedInfo, setExpandedInfo] = useState(false)
    const [currentLocation, setCurrentLocation] = useState("none")
    const [closedCaseModalOpen, setClosedCaseModalOpen] = useState(false)
    const [bikeInfo, setBikeInfo] = useState<any>(null)
    const [margin, setMargin] = useState(100);
    const [gpsLocation, setGpsLocation] = useState({ lat: 0, lng: 0})
    const [bluetoothOn, setBluetoothOn] = useState(false)
    const { backendEndpoint, liveUpdatesEndpoint } = endpoints

    const location = useLocation()
    const token = location.pathname.replace('/follow/', '')

    useEffect(() => {
        const eventStream = new EventSource(`${liveUpdatesEndpoint}/real-time/tracking?follow_token=${token}`)

        eventStream.onmessage = (m: any) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const [_, location, positionedAt, margin] = JSON.parse(m.data)
            setGpsLocation(location)
            setLastSeen(formatDateTimeToLastSeen(positionedAt))
            setMargin(margin)
        }
    },[token, liveUpdatesEndpoint])

    useEffect(() => {
        axios.get(`${backendEndpoint}/tracking/${token}`).then((res) => {
            const { data } = res.data
            const { name, location, margin, received_at, imei, frame_number, brand, model, type, color, license_plate } = data.entity
            setLastSeen(formatDateTimeToLastSeen(received_at))
            setBikeInfo({name, imei, brand, model, frameNumber: frame_number, type, color, licensePlate: license_plate })
            const { lat, lng } = location
            setGpsLocation({ lat, lng })
            setMargin(margin === 0 ? 100 : margin)
        }).catch((e) => {
            console.log(e)
            setClosedCaseModalOpen(true)
        })
    }, [token, backendEndpoint])

    const shareLocation = () => {
            copyLocation(document.location.href);
            setSnackbar({message: 'Tracking url copied!', open: true, severity: 'success' })
    }

    const turnOnBluetooth = () => {
        if (!bluetoothOn) {
            axios.put(`${backendEndpoint}/tracking/${token}/commands/bluetooth`).then(() => {
                setBluetoothOn(true)
                setSnackbar({message: 'Bluetooth switched on!', open: true, severity: 'success' })
                setTimeout(() => setBluetoothOn(false), 600000)
            }).catch(err => setSnackbar({message: err.message, open: true, severity: 'error' }))
        }
    }

    const requestRecentLocation = () => {
        axios.put(`${backendEndpoint}/tracking/${token}/commands/locate`).then(() => {
            setSnackbar({message: 'Location request sent to tracker!', open: true, severity: 'success' })
        }).catch((err) => setSnackbar({message: err.message, open: true, severity: 'error' }))
    }

    return (
        <Box className={classes.root}>
            <Map location={gpsLocation} margin={margin} setCurrentLocation={setCurrentLocation} />

            {bikeInfo && <Card className={classes.card}>
                <CardHeader
                    action={
                        <div style={{ paddingTop: '6px' }}>
                            <Tooltip title={bluetoothOn ? "Bluetooth on" : "Turn bluetooth on"}>
                                <IconButton style={{ color: '#EEF0F2' }} aria-label="bluetooth" onClick={turnOnBluetooth} className={bluetoothOn ? classes.bluetoothOn : ''} >
                                    <BluetoothSearchingIcon />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title={"Request new location"}>
                                <IconButton style={{ color: '#EEF0F2' }} aria-label="location" onClick={requestRecentLocation}>
                                    <NotListedLocationIcon/>
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Copy follow page url">
                                <IconButton style={{ color: '#EEF0F2' }} aria-label="share" onClick={shareLocation}>
                                    <LaunchIcon />
                                </IconButton>
                            </Tooltip>
                        </div>
                    }
                    title={ <div style={{display: 'flex', alignItems: 'center'}}><IconButton
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: expandedInfo,
                        })}
                        onClick={() => setExpandedInfo(!expandedInfo)}
                        aria-expanded={expandedInfo}
                        aria-label="show more"
                    >
                        <ExpandMoreIcon style={{color: 'white'}}/>
                    </IconButton></div>}
                    style={{backgroundColor: theme.palette.primary.main, color: 'white', padding: '4px 14px'}}
                />
                <List className={classes.list} style={{height: !expandedInfo ? 'auto' : 0, padding: !expandedInfo ? '8px 0' : 0}}>
                    <ListItem>
                        <ListItemAvatar>
                            <Avatar className={classes.avatar}>
                                <RoomIcon/>
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={currentLocation === 'none' ? 'No close address found...' : currentLocation}/>
                        <Tooltip title={"Open in google maps"}>
                            <IconButton
                                onClick={() => window.open(`https://www.google.com/maps/place/${currentLocation.replaceAll(' ', '+')}/`, "_blank")}>
                                <ExploreIcon style={{color: theme.palette.type === 'dark' ? 'white' : '#173c60'}}/>
                            </IconButton>
                        </Tooltip>
                    </ListItem>
                    <ListItem>
                        <ListItemAvatar>
                            <Avatar className={classes.avatar}>
                                <DirectionsBikeIcon/>
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={bikeInfo.name || ''} secondary={`${bikeInfo.color || ''} ${bikeInfo.type || ''}`}/>
                        <IconButton
                            className={clsx(classes.expand, {
                                [classes.expandOpen]: expandedVehicle,
                            })}
                            onClick={() => setExpandedVehicle(!expandedVehicle)}
                            aria-expanded={expandedVehicle}
                            aria-label="show more"
                        >
                            <ExpandMoreIcon style={{color: theme.palette.type === 'dark' ? 'white' : '#173c60'}}/>
                        </IconButton>
                    </ListItem>
                    <Collapse in={expandedVehicle} timeout="auto" unmountOnExit>
                        <List className={classes.list}>
                            <ListItemText primary={bikeInfo.brand ? `${bikeInfo.brand} ${bikeInfo.model || ''}` : 'Model and brand unknown'} className={classes.listItem} secondary={bikeInfo.imei || ''} />
                            <ListItemText primary={"Frame number"} secondary={bikeInfo.frameNumber || ''}
                                          className={classes.listItem}/>
                            {bikeInfo.licensePlate && <ListItemText primary={"License plate"} secondary={bikeInfo.licensePlate} className={classes.listItem}/>}
                        </List>
                    </Collapse>
                    <ListItem>
                        <ListItemAvatar>
                            <Avatar className={classes.avatar}>
                                <AccessTimeIcon/>
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={"Last seen"} secondary={lastSeen}/>
                    </ListItem>
                </List>
            </Card>}
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={closedCaseModalOpen}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                    classes: {
                        root: classes.backDrop
                    }
                }}
            >
                <Fade in={closedCaseModalOpen}>
                    <div className={classes.caseClosed}>
                        <Typography variant={"h6"} id="transition-modal-title" style={{margin: '10px 0 20px', color: theme.palette.type === 'dark' ? 'white' : 'black'}}>Follow link expired</Typography>
                    </div>
                </Fade>
            </Modal>
            <Snackbar snackbar={snackbar} setSnackbar={setSnackbar} />
        </Box>)

}

export default Follow;
